import { API_ENPOINTS } from '../../constants/api';
import { get, put, post } from '../../utils/requests';
import { deserializeDefaultValues, serializeDefaultValues } from './serializers';

const DEFAULT_VALUE_API = API_ENPOINTS.defaultValues;

export const fetchDefaultValue = () => {
  const endpoint = `${DEFAULT_VALUE_API}/`;
  return get(endpoint).then(deserializeDefaultValues);
};

export const updateDefaultValues = (values) => {
  const endpoint = `${DEFAULT_VALUE_API}/Batch`;
  return put(endpoint, serializeDefaultValues(values));
};



// WEBPACK FOOTER //
// src/actions/defaultValues/apiRequests.js